import React, { useState } from 'react';
import Bar from '../charts/Bar';
import DelayRender from '../DelayRender';
import useMetronome from '../utility/useMetronome';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';

const Counts = ({ ...props }) => {
    const [data, setData] = useState([]);

    const [fetchData, setFetchData] = useState(5);

    useMetronome(() => {
        if (fetchData > 0) {
            setFetchData(fetchData - 1)
            HamQuest.get(QuestRoute.dashboard.count)
                .then(res => setData(res))
                .catch(ex => console.error(ex))
        }
    }, 60000)

    const chartProps = {
        yAxisLabel: 'Items',
        xAxis: data.map(e => e.location),
        data: [...new Set(data.flatMap(e => e.items.map(item => item.label)))]
            .map(name => ({
                name,
                data: data.map(loc => loc.items.find(item => item.label === name)?.totalCount || 0)
            })),
        stacked: true,
    }


    return (
        <DelayRender>
            <Bar chartProps={chartProps} />
        </DelayRender>
    );
}

export default Counts;